package one.healthium.paywall.ui.components

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.domain.paywall.models.PaywallMainPlansView
import one.healthium.domain.paywall.models.ProductControl
import one.healthium.paywall.ui.models.ProductUiModel

@Composable
fun PaywallMainPlansView(
    model: PaywallMainPlansView,
    products: List<ProductUiModel>,
    onClick: (ProductControl) -> Unit,
    selectedProductId: String?,
) {
    val config = model.config

    PlansControlsView(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = config.horizontalInset?.dp ?: 24.dp),
        controls = config.controls,
        products = products,
        selectedProductId = selectedProductId,
        onClick = onClick,
        minHeight = config.height?.dp,
    )
}
